module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "divPDFMobile"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "pdfCanvas"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "btnZoomIn",
    attrs: {
      "color": "warning",
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomMobile('+')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "btnZoomOut",
    attrs: {
      "color": "warning",
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomMobile('-')
      }
    }
  }, [_c('v-icon', [_vm._v("remove")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da1f0e46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PDFMobile.vue
// module id = 913
// module chunks = 2